<script setup lang="ts">
import Skeleton from 'primevue/skeleton';

const props = withDefaults(defineProps<{ rows?: number, compact?: boolean }>(), { rows: 9 });
</script>
<template>
  <div class="container mx-auto">
    <div class="grid grid-cols-12 grid-rows-9 gap-4">
      <Skeleton v-if="rows >= 1" class="col-span-6 mb-2" :height="props.compact ? '1rem' : '2rem'" />
      <Skeleton v-if="rows >= 1" class="col-span-6 mb-2" :height="props.compact ? '1rem' : '2rem'" />

      <Skeleton v-if="rows >= 2" class="col-span-6 mb-2" :height="props.compact ? '1rem' : '2rem'" />
      <Skeleton v-if="rows >= 2" class="col-span-6 mb-2" :height="props.compact ? '1rem' : '2rem'" />

      <Skeleton v-if="rows >= 3" class="col-span-12 mb-2" :height="props.compact ? '1rem' : '2rem'" />

      <Skeleton v-if="rows >= 4" class="col-span-12 mb-2" :height="props.compact ? '1rem' : '2rem'" />

      <Skeleton v-if="rows >= 5" class="col-span-4 mb-2" :height="props.compact ? '1rem' : '2rem'" />
      <Skeleton v-if="rows >= 5" class="col-span-8 mb-2" :height="props.compact ? '1rem' : '2rem'" />

      <Skeleton v-if="rows >= 6" class="col-span-4 mb-2" :height="props.compact ? '1rem' : '2rem'" />
      <Skeleton v-if="rows >= 6" class="col-span-4 mb-2" :height="props.compact ? '1rem' : '2rem'" />
      <Skeleton v-if="rows >= 6" class="col-span-4 mb-2" :height="props.compact ? '1rem' : '2rem'" />

      <Skeleton v-if="rows >= 7" class="col-span-12 mb-2" :height="props.compact ? '1rem' : '2rem'" />

      <Skeleton v-if="rows >= 8" class="col-span-12 mb-2" :height="props.compact ? '2rem' : '4rem'" />

      <Skeleton v-if="rows >= 9" class="col-span-6" :height="props.compact ? '1rem' : '2rem'" />
      <Skeleton v-if="rows >= 9" class="col-span-6" :height="props.compact ? '1rem' : '2rem'" />
    </div>
  </div>
</template>
